import styled from "styled-components";

const SearchTextContainer = styled.div`
  position: relative;
  
  input {
    border-left: 0;
    border-top: 0;
    border-right: 0;
    padding: 0;
    height: 2rem;
    margin-top: 0;

    &:focus {
      box-shadow: none;
    }
  }

  > svg {
    color: ${({ theme }) => theme.palette.grayscale[3]};
    position: absolute;
    right: -1rem !important;
    top: 0.5rem;
  }
`;

export default SearchTextContainer;
